import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { surfaceM, grayLightM, selectedM } from 'web-ui-kit/colors';
import { unsegmentedControlWithBackgroundColorClicked } from 'web-ui-kit/events';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2, _templateObject3;
/**
 * A selectable image with fixed aspect ratio.
 */


function UnsegmentedControlWithBackgroundColor(_ref) {
  var _ref$aspectRatio = _ref.aspectRatio,
      aspectRatio = _ref$aspectRatio === void 0 ? 1 : _ref$aspectRatio,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? '' : _ref$color,
      _ref$dispatch = _ref.dispatch,
      dispatch = _ref$dispatch === void 0 ? function () {} : _ref$dispatch,
      name = _ref.name,
      _ref$status = _ref.status,
      status = _ref$status === void 0 ? 'unselected' : _ref$status;

  var handleClick = function handleClick() {
    dispatch({
      type: unsegmentedControlWithBackgroundColorClicked,
      payload: {
        name: name,
        status: status
      }
    });
  };

  var disabledStyle = ['disabled', 'selected-disabled'].includes(status);
  var selectedStyle = ['selected', 'selected-disabled'].includes(status);
  var Button = styles.Button,
      ColorContainer = styles.ColorContainer,
      DiagonalLine = styles.DiagonalLine;
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      aspectRatio: aspectRatio,
      className: className,
      "data-testid": "".concat(name, " ").concat(status),
      onClick: handleClick,
      disabledStyle: disabledStyle,
      selectedStyle: selectedStyle
    },
    /*#__PURE__*/
    React.createElement(ColorContainer, {
      color: color
    }, disabledStyle &&
    /*#__PURE__*/
    React.createElement(DiagonalLine, null)))
  );
}

UnsegmentedControlWithBackgroundColor.propTypes = {
  /** Allows extending styling with styled(UnsegmentedControlWithImageOnly) constructor. */
  className: PropTypes.string,

  /** For reporting events up to parent */
  dispatch: PropTypes.func,

  /** A name for the control.
   * Not visible to users but useful for event handling.
  */
  name: PropTypes.string.isRequired,

  /** The control status. One of: */
  status: PropTypes.oneOf(['unselected', 'selected', 'disabled', 'selected-disabled'])
};
var styles = {
  Button: styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    /** disable default browser button styles */\n    appearance: none;\n    border: none;\n    outline: none;\n\n    /** Make the button a fixed aspect ratio */\n    height: 0;\n    padding-bottom: calc(", "% - 0.1875rem);\n    width: 100%;\n\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    cursor: pointer;\n    position: relative;\n\n    ", "\n  "])), function (p) {
    return 1 / p.aspectRatio * 100;
  }, surfaceM, grayLightM, function (p) {
    return p.selectedStyle && "\n      /** Sizing up the selected border with so using an after\n        * psuedo element to make sure the image does not jump\n        */\n      border-color: ".concat(surfaceM, ";\n      &::after {\n        content: '';\n        position: absolute;\n        top: -2px;\n        left: -2px;\n        width: 100%;\n        height: 100%;\n        border: 2px solid ").concat(selectedM, ";\n        border-radius: 4px;\n      }\n    ");
  }),
  ColorContainer: styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    position: absolute;\n    top: 0.125rem;\n    left: 0.125rem;\n    width: calc(100% - 0.25rem);\n    height: calc(100% - 0.25rem);\n    background-color: ", ";\n\n    border-radius: 4px;\n  "])), function (_ref2) {
    var color = _ref2.color;
    return color;
  }),
  DiagonalLine: styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    position:   absolute;\n    top: 0;\n    left: 0;\n    background: -moz-linear-gradient(-45deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 46.5%, rgba(255,255,255,1) 46.6%, rgba(255,255,255,1) 52.5%, rgba(255,255,255,0) 52.6%, rgba(255,255,255,0) 100%); /* FF3.6-15 */\n    background: -webkit-linear-gradient(-45deg, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 46.5%,rgba(255,255,255,1) 46.6%,rgba(255,255,255,1) 52.5%,rgba(255,255,255,0) 52.6%,rgba(255,255,255,0) 100%); /* Chrome10-25,Safari5.1-6 */\n    background: linear-gradient(135deg, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 46.5%,rgba(255,255,255,1) 46.6%,rgba(255,255,255,1) 52.5%,rgba(255,255,255,0) 52.6%,rgba(255,255,255,0) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00c4c4c4', endColorstr='#00c4c4c4',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */\n  "])))
};
export default UnsegmentedControlWithBackgroundColor;